import axios from "axios";
import router from "@/router";
import { Message } from "element-ui";
const baseURL = window.config.url;

export const prefix = "api";
const timeout = 600000; // 10分钟
let errotTime = null;
const requestBase = axios.create({
  baseURL,
  timeout,
  headers: {
    "Cache-Control": "no-cache"
  }
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any

requestBase.interceptors.request.use(
  config => {
    config.headers["Authorization"] = "Bearer " + localStorage.getItem("token");
    config.headers["Accept"] = "application/json";
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
requestBase.interceptors.response.use(
  response => {
    const { status } = response;
    if (status !== 200) {
      Message.error(response.data.message);
      return Promise.reject(response);
    }
    if (response.config.responseType === "blob") {
      return response.data;
    }
    if (response.data.status == 200) {
      return Promise.resolve(response.data);
    } else {
      Message.error(response.data.message);
    }
  },
  error => {
    if (!errotTime) {
      if (error.response && error.response.status === 500) {
        const { message } = error.response.data;
        Message.error("服务器错误！");
        errotTime = setTimeout(() => {
          errotTime = null;
        }, 500);
      } else if (error.response && error.response.status === 401) {
        router.push("/login");
        Message.error("登录状态过期，请重新登录");
        return;
      } else {
        errotTime = setTimeout(() => {
          errotTime = null;
        }, 500);
      }

      return Promise.reject(error);
    }
  }
);

/**
 * @param {AxiosRequestConfig} Config 接口地址
 * @param {string}  prefixValue 接口地址
 * @returns { AxiosPromise | Promise<any>} 返回接口
 */
/**
 * @description:
 * @param {*} Config
 * @param {*} prefixValue
 * @return {*}
 */
/**
 * @description:
 * @param {*} Config
 * @param {*} prefixValue
 * @return {*}
 */
function request(Config, prefixValue = "") {
  requestBase.defaults.baseURL = Config.baseURL ? Config.baseURL : baseURL;
  Config.url = `${prefixValue}${Config.url}`;
  return requestBase(Config);
}

export default request;



// WEBPACK FOOTER //
// ./src/utils/axios.js